import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import BasicFormField from '../../../common/formFields/basicFormField';
import TextArea from '../../../common/textarea';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import ColorPickerField from '../../../common/ColorPickerField';
import FormSection from '../../../common/FormSection';
import FileInput from '../../../common/fileInput';
import { TERRITORIES } from '../constants';
import UploadImageAsset from './UploadImageAsset';
import SelectMultipleField from './SelectMultipleField';
import SelectField from './SelectField';

const CustomAppForm = ({ extension }) => (
  <div className="layout">
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">{t('admin:brands.custom_app_form.app_store_settings_heading')}</div>
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.ios_android_required_placeholder')}
      label={t('admin:brands.custom_app_form.app_store_name_label')}
      name="extension.iTunesName"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.ios_android_required_placeholder')}
      label={t('admin:brands.custom_app_form.app_name_label')}
      name="extension.name"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.ios_android_required_placeholder')}
      label={t('admin:brands.custom_app_form.app_display_name_label')}
      name="extension.appName"
      maxLength="30"
      wrapperClass="layout__item u-1"
    />
    <div className="layout__item">
      <div className="c-label-new">{t('admin:brands.custom_app_form.app_store_description_label')}</div>
      <TextArea
        className="c-textarea"
        name="extension.iTunesDescription"
        placeholder={t('admin:brands.custom_app_form.ios_android_required_and_placeholder')}
        maxLength="4000"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:brands.custom_app_form.app_store_short_description_label')}</div>
      <TextArea
        className="c-textarea"
        name="extension.googlePlayShortDescription"
        placeholder={t('admin:brands.custom_app_form.android_required_placeholder')}
        maxLength="80"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:brands.custom_app_form.app_store_keywords_label')}</div>
      <TextArea
        className="c-textarea"
        name="extension.iTunesKeywords"
        placeholder={t('admin:brands.custom_app_form.ios_required_placeholder')}
        maxLength="100"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:brands.custom_app_form.internal_app_notes_label')}</div>
      <TextArea
        className="c-textarea"
        name="extension.notes"
        placeholder={t('admin:brands.custom_app_form.app_notes_placeholder')}
        maxLength="4000"
      />
    </div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">{t('admin:brands.custom_app_form.appearance_heading')}</div>
    <UploadImageAsset name="extension.appIconImage" label={t('admin:brands.custom_app_form.app_icon_image_label')} />
    <UploadImageAsset name="extension.appIconForegroundImage" label={t('admin:brands.custom_app_form.app_icon_foreground_image_label')} />
    <UploadImageAsset name="extension.googlePlayFeatureGraphicImage" label={t('admin:brands.custom_app_form.app_store_feature_graphic_image_label')} />
    <UploadImageAsset name="extension.logoImage" label={t('admin:brands.custom_app_form.logo_image_label')} />
    <UploadImageAsset name="extension.smallLogoImage" label={t('admin:brands.custom_app_form.small_logo_image_label')} />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <ColorPickerField name="extension.primaryColor" label={t('admin:brands.custom_app_form.primary_color_label')} />
    <ColorPickerField name="extension.primaryColorDarker" label={t('admin:brands.custom_app_form.primary_color_darker_label')} />
    <ColorPickerField name="extension.secondaryColor" label={t('admin:brands.custom_app_form.secondary_color_label')} />
    <ColorPickerField name="extension.linkColor" label={t('admin:brands.custom_app_form.link_color_label')} />
    <ColorPickerField name="extension.primaryFontColor" label={t('admin:brands.custom_app_form.primary_font_color_label')} />
    <div className="c-separator u-mv" />
    <FormSection title={t('admin:brands.custom_app_form.appearance_legacy_heading')}>
      <UploadImageAsset name="extension.backgroundImage" label={t('admin:brands.custom_app_form.background_image_label')} />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
      <ColorPickerField name="extension.signupButtonColor" label={t('admin:brands.custom_app_form.signup_button_color_label')} />
      <ColorPickerField name="extension.loginButtonColor" label={t('admin:brands.custom_app_form.login_button_color_label')} />
      <ColorPickerField name="extension.barColor" label={t('admin:brands.custom_app_form.bar_color_label')} />
      <ColorPickerField name="extension.barColorAlpha" label={t('admin:brands.custom_app_form.bar_color_alpha_label')} />
      <SelectField
        className="c-select"
        name="extension.region"
        label={t('admin:brands.custom_app_form.app_region_label')}
        options={TERRITORIES.map(territory => ({ ...territory, label: t(territory.labelKey) }))}
        empty
      />
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.background_alpha_label')}
        label={t('admin:brands.custom_app_form.background_alpha_label')}
        name="extension.backgroundAlpha"
        maxLength="2"
        normalize={value => (value ? Number(value) : null)}
      />
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.logo_leading_label')}
        label={t('admin:brands.custom_app_form.logo_leading_label')}
        name="extension.logoLeading"
        maxLength="3"
        normalize={value => (value ? Number(value) : null)}
      />
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.logo_trailing_label')}
        label={t('admin:brands.custom_app_form.logo_trailing_label')}
        name="extension.logoTrailing"
        maxLength="3"
        normalize={value => (value ? Number(value) : null)}
      />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
      <CheckboxSwitch
        name="extension.oversizedSmallLogo"
        id="extension.oversizedSmallLogo"
        label={t('admin:brands.custom_app_form.oversized_small_logo_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.centerLogo"
        id="extension.centerLogo"
        label={t('admin:brands.custom_app_form.center_homescreen_logo_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.usePostal"
        id="extension.usePostal"
        label={t('admin:brands.custom_app_form.use_postal_instead_of_zip_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.noTaxLabel"
        id="extension.noTaxLabel"
        label={t('admin:brands.custom_app_form.hide_tax_label_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.showPromotions"
        id="extension.showPromotions"
        label={t('admin:brands.custom_app_form.show_promotions_tab_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.showHours"
        id="extension.showHours"
        label={t('admin:brands.custom_app_form.show_hours_tab_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
    </FormSection>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mt-- u-mb-" >{t('admin:brands.custom_app_form.apple_developer_settings_heading')}</div>
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.bundle_identifier_label')}
      label={t('admin:brands.custom_app_form.bundle_identifier_label')}
      name="extension.identifier"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.merchant_identifier_label')}
      label={t('admin:brands.custom_app_form.merchant_identifier_label')}
      name="extension.merchantId"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.team_name_label')}
      label={t('admin:brands.custom_app_form.team_name_label')}
      name="extension.teamName"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.developer_team_id_label')}
      label={t('admin:brands.custom_app_form.developer_team_id_label')}
      name="extension.teamId"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.itc_provider_label')}
      label={t('admin:brands.custom_app_form.itc_provider_label')}
      name="extension.itcProvider"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.app_store_team_id_label')}
      label={t('admin:brands.custom_app_form.app_store_team_id_label')}
      name="extension.itunesTeamId"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.itunes_link_label')}
      label={t('admin:brands.custom_app_form.itunes_link_label')}
      name="extension.iTunesLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.itunes_marketing_link_label')}
      label={t('admin:brands.custom_app_form.itunes_marketing_link_label')}
      name="extension.iTunesMarketingLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.itunes_support_link_label')}
      label={t('admin:brands.custom_app_form.itunes_support_link_label')}
      name="extension.iTunesSupportLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.sku_label')}
      label={t('admin:brands.custom_app_form.sku_label')}
      name="extension.sku"
      maxLength="255"
    />
    <SelectMultipleField
      name="extension.territories"
      label={t('admin:brands.custom_app_form.app_store_territories_label')}
      options={TERRITORIES.map(territory => ({ ...territory, label: t(territory.labelKey) }))}
    />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.key_id_label')}
      label={t('admin:brands.custom_app_form.app_store_connect_api_key_id_label')}
      name="extension.appStoreConnectApiKeyId"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.issuer_id_label')}
      label={t('admin:brands.custom_app_form.app_store_connect_api_issuer_id_label')}
      name="extension.appStoreConnectApiIssuerId"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.app_store_connect_version_label')}
      label={t('admin:brands.custom_app_form.app_store_connect_version_label')}
      name="extension.appStoreConnectVersion"
      maxLength="255"
      normalize={value => (value || null)}
      disabled
    />
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">{t('admin:brands.custom_app_form.app_store_connect_api_key_label')}</div>
      <FileInput
        label={extension.appStoreConnectApiKey ? t('admin:brands.custom_app_form.re_upload_button') : t('admin:brands.custom_app_form.upload_button')}
        name="extension.appStoreConnectApiKey"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:brands.custom_app_form.app_store_connect_account_status_label')}</div>
      <TextArea
        className="c-textarea"
        name="extension.appStoreConnectStatus"
        placeholder={t('admin:brands.custom_app_form.no_status_placeholder')}
        maxLength="4000"
        disabled
      />
    </div>
    <div className="c-separator u-mv" />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">{t('admin:brands.custom_app_form.google_developer_settings_heading')}</div>
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.application_id_label')}
      label={t('admin:brands.custom_app_form.application_id_label')}
      name="extension.applicationId"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.play_store_link_label')}
      label={t('admin:brands.custom_app_form.play_store_link_label')}
      name="extension.playStoreLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.google_client_id_placeholder')}
      label={t('admin:brands.custom_app_form.google_client_id_label')}
      name="extension.googleClientId"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.google_play_store_version_label')}
      label={t('admin:brands.custom_app_form.google_play_store_version_label')}
      name="extension.googlePlayVersion"
      maxLength="255"
      normalize={value => (value || null)}
      disabled
    />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">{t('admin:brands.custom_app_form.android_firebase_config_label')}</div>
      <FileInput
        label={extension.firebaseConfig ? t('admin:brands.custom_app_form.re_upload_button') : t('admin:brands.custom_app_form.upload_button')}
        name="extension.firebaseConfig"
      />
    </div>
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">{t('admin:brands.custom_app_form.ios_firebase_config_label')}</div>
      <FileInput
        label={extension.iosFirebaseConfig ? t('admin:brands.custom_app_form.re_upload_button') : t('admin:brands.custom_app_form.upload_button')}
        name="extension.iosFirebaseConfig"
      />
    </div>
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">{t('admin:brands.custom_app_form.service_account_key_label')}</div>
      <FileInput
        label={extension.serviceAccountKey ? t('admin:brands.custom_app_form.re_upload_button') : t('admin:brands.custom_app_form.upload_button')}
        name="extension.serviceAccountKey"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:brands.custom_app_form.google_play_account_status_label')}</div>
      <TextArea
        className="c-textarea"
        name="extension.googlePlayStatus"
        placeholder={t('admin:brands.custom_app_form.no_status_placeholder')}
        maxLength="4000"
        disabled
      />
    </div>
    <div className="c-separator u-mv" />
    <FormSection title={t('admin:brands.custom_app_form.third_party_integrations_legacy_heading')}>
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">{t('admin:brands.custom_app_form.facebook_ads_settings_heading')}</div>
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.facebook_app_identifier_label')}
        label={t('admin:brands.custom_app_form.facebook_app_identifier_label')}
        name="extension.facebookAppIdentifier"
        maxLength="255"
      />
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.facebook_display_name_label')}
        label={t('admin:brands.custom_app_form.facebook_display_name_label')}
        name="extension.facebookDisplayName"
        maxLength="255"
      />
      <div className="c-separator u-mv" />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">{t('admin:brands.custom_app_form.branch_io_ads_settings_heading')}</div>
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.branch_key_label')}
        label={t('admin:brands.custom_app_form.branch_key_label')}
        name="extension.branchKey"
        maxLength="255"
      />
      <div className="c-separator u-mv" />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">{t('admin:brands.custom_app_form.payments_heading')}</div>
      <CheckboxSwitch
        name="extension.payworks"
        id="extension.payworks"
        label={t('admin:brands.custom_app_form.payworks_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
    </FormSection>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">{t('admin:brands.custom_app_form.advanced_options_heading')}</div>
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.developer_username_placeholder')}
      label={t('admin:brands.custom_app_form.developer_username_label')}
      name="extension.username"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.developer_encrypted_password_placeholder')}
      label={t('admin:brands.custom_app_form.developer_encrypted_password_label')}
      name="extension.encryptedPassword"
      type="password"
      maxLength="255"
    />
    <BasicFormField
      placeholder={t('admin:brands.custom_app_form.app_update_group_placeholder')}
      label={t('admin:brands.custom_app_form.app_update_group_label')}
      name="extension.appUpdateGroup"
      maxLength="255"
    />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <CheckboxSwitch
      name="extension.shouldUpdate"
      id="extension.shouldUpdate"
      label={t('admin:brands.custom_app_form.should_allow_app_updates_label')}
      wrapperClass="layout__item u-1/2-medium-and-up"
    />
    <div className="c-separator u-mv" />
    <FormSection title={t('admin:brands.custom_app_form.advanced_options_legacy_heading')}>
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.scheme_name_placeholder')}
        label={t('admin:brands.custom_app_form.scheme_name_label')}
        name="extension.scheme"
        maxLength="255"
      />
      <BasicFormField
        placeholder={t('admin:brands.custom_app_form.passphrase_placeholder')}
        label={t('admin:brands.custom_app_form.passphrase_label')}
        name="extension.passphrase"
        type="password"
        maxLength="255"
      />
      <CheckboxSwitch
        name="extension.facebookLoginDisabled"
        id="extension.facebookLoginDisabled"
        label={t('admin:brands.custom_app_form.disable_facebook_login_button_label')}
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
    </FormSection>
  </div>
);

CustomAppForm.propTypes = {
  extension: PropTypes.object,
};

CustomAppForm.defaultProps = {
  extension: {},
};

export default CustomAppForm;
